<div class="page-container gap-24">
  <div class="page-title">
    <span class="font-bold-display-medium">
      Wir freuen uns auf Deine Rückmeldung
    </span>
  </div>
  <span class="align-self-stretch font-regular-body-large">
    Da wir bereits intensiv an weiteren Funktionen für Dich arbeiten, sind wir
    am besten über das folgende Kontaktformular erreichbar. Wir sind ein
    kostenfreier Service, daher hoffen wir auf Dein Verständnis, dass wir u.U.
    zeitverzögert antworten. Das Team vom InWi beantwortet Dir gerne Deine
    schriftlichen Fragen und ist zudem für konstruktive Kritik, sowie Lob
    jederzeit dankbar.
  </span>
  <div class="flex-c align-center">
    <div class="contact-container">
      <form
        [formGroup]="contactForm"
        (submit)="submit()"
        class="contact-form-area">
        <div class="contact-form">
          <div class="contact-form-row">
            <div class="input-simple flex-1-1-0">
              <label for="firstName" class="input-label">
                Dein Vorname{{
                  fieldRequired(contactForm.get('firstName')) ? '*' : ''
                }}
              </label>
              <input
                id="firstName"
                type="text"
                class="input-field"
                formControlName="firstName"
                placeholder="Vorname"
                autocomplete="given-name" />
              <!-- Error Messages -->
              <app-error-message
                [formField]="contactForm.get('firstName')"></app-error-message>
            </div>
            <div class="input-simple flex-1-1-0">
              <label for="lastName" class="input-label">
                Dein Nachname{{
                  fieldRequired(contactForm.get('lastName')) ? '*' : ''
                }}
              </label>
              <input
                id="lastName"
                type="text"
                class="input-field"
                formControlName="lastName"
                placeholder="Nachname"
                autocomplete="family-name" />
              <!-- Error Messages -->
              <app-error-message
                [formField]="contactForm.get('lastName')"></app-error-message>
            </div>
          </div>
          <div class="contact-form-row">
            <div class="input-simple flex-1-1-0">
              <label for="email" class="input-label">
                Deine E-Mail-Adresse{{
                  fieldRequired(contactForm.get('email')) ? '*' : ''
                }}
              </label>
              <input
                id="email"
                type="email"
                class="input-field"
                placeholder="E-Mail"
                formControlName="email"
                autocomplete="email" />
              <app-error-message
                [formField]="contactForm.get('email')"></app-error-message>
            </div>
            <div class="input-simple flex-1-1-0">
              <label for="subject" class="input-label">
                Betreff{{
                  fieldRequired(contactForm.get('subject')) ? '*' : ''
                }}
              </label>
              <input
                id="subject"
                type="text"
                class="input-field"
                placeholder="Betreff"
                formControlName="subject" />
              <!-- Error Messages -->
              <app-error-message
                [formField]="contactForm.get('subject')"></app-error-message>
            </div>
          </div>
          <div class="input-simple align-self-stretch">
            <div class="input-label-wrapper">
              <label for="message" class="input-label">
                Deine Nachricht{{
                  fieldRequired(contactForm.get('message')) ? '*' : ''
                }}
              </label>
              <div class="input-label-hint">
                {{ getTextAreaLength(contactForm.controls['message']) }}
                /
                {{ getMaxLengthFromValidator(contactForm.controls['message']) }}
              </div>
            </div>
            <textarea
              id="message"
              name="message"
              class="input-textarea"
              rows="6"
              formControlName="message"
              placeholder="Deine Nachricht"></textarea>
          </div>
        </div>
        @if (!userService.currentUser$.value) {
          <div class="flex-c gap-4">
            <div
              class="flex-r align-center gap-8 align-self-stretch"
              [class.invalid-checkbox]="
                contactForm.get('privacyConfirmation').invalid &&
                contactForm.get('privacyConfirmation').touched
              ">
              <div class="inwi-checkbox">
                <input
                  id="privacyConfirmation"
                  type="checkbox"
                  name="privacyConfirmation"
                  formControlName="privacyConfirmation" />
              </div>
              <div class="flex-c align-start gap-4 flex-1-0-0">
                <label for="agb" class="font-regular-body-large">
                  Hiermit bestätige ich meine Kenntnis von den
                  <a
                    class="font-color-black"
                    href="/privacy-policy"
                    target="_blank">
                    Datenschutzinformationen </a
                  >.
                </label>
              </div>
            </div>
            @if (
              contactForm.get('privacyConfirmation').invalid &&
              contactForm.get('privacyConfirmation').touched
            ) {
              <div class="inwi-error-container show-overflow">
                <div class="inwi-text-error font-regular-label-large">
                  Sie müssen die Datenschutzinformationen akzeptieren.
                </div>
              </div>
            }
          </div>
        }
        <div class="contact-action">
          <button
            class="inwi-text-button-large-primary"
            type="submit"
            [disabled]="isLoading">
            <div class="button-content">
              <div class="button-text">Nachricht Senden</div>
            </div>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
